import {Component, OnInit, ViewChild} from '@angular/core';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {UserService} from '../../admin-services/user.service';
import {first} from 'rxjs/operators';
import {TranslateModule} from '@ngx-translate/core';
import {PaginationComponent} from '../../../shared/components/ux/pagination/pagination.component';
import {RouterLink} from '@angular/router';
import {AvatarFillerComponent} from '../../../shared/components/ux/avatar-filler/avatar-filler.component';
import {DatePipe, NgIf} from '@angular/common';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: true,
    imports: [MatIconModule, MatFormFieldModule, MatInputModule, FormsModule, NgxIntlTelInputModule, NgIf, MatTableModule, AvatarFillerComponent, RouterLink, PaginationComponent, TranslateModule, DatePipe]
})
export class UsersComponent implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['id', 'name', 'progress', 'fruit'];

  public users: any[] = []

  dataSource;
  public page:number=0;
  public maxPage:number = 0;
  public hasMore:boolean = false;
  public perPage: string = '10';
  public isloading: boolean = false;
  public search: string = null;

  constructor(
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.changePage('next');
  }

  changePage(direction) {
    this.isloading = true;
    this.users = [];
    if (direction == 'next') {
      this.page += 1;
    }
    if (direction == 'previous'){
      this.page -= 1;
    }
    this.userService.getAllUsers(this.page, this.perPage, this.search).pipe(first()).subscribe(data=> {
      this.users = data.users.data;
      this.users.forEach(data => {
        data['name'] = ((data.firstname ? data.firstname : 'N/A') + ' ' + (data.lastname ? data.lastname : 'N/A'));
      })
      this.maxPage = data.users.last_page;
      this.hasMore = data.hasMore;
      this.dataSource = new MatTableDataSource<any>(this.users);
      // this.dataSource.sort = this.sort;
      this.isloading = false;
    })

  }

  changePerPage(value) {
    this.perPage = value;
    this.refresh();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  refresh() {
    this.page = 0;
    this.changePage('next');
  }

  doSearch(){
    this.ngOnInit();
  }
}
